import React from 'react';
import { connect } from 'react-redux';

import { TriggerList } from './TriggerList';
import { Edit } from 'components/detail';
import { SimpleForm } from 'components/form';
import { TextInput, BooleanInput, DateInput, HiddenInput, SelectInput } from 'components/input';
import DisabledInput from "components/input/DisabledInput";

import { 
  crudGetOne as crudGetOneAction,
  crudGetList as crudGetListAction,
} from 'actions/dataActions';

import * as urls from '../urls';
import * as utils from '../utils';
import { getPaymentTypeChoices } from "../PromotionCreate";


const PromotionEditBase = (props) => {
  const { formValues, payment_types } = props;
  const show_quota = formValues.quota_type === utils.QUOTA_TYPE_LIMITED;
  const payment_type_choices =  getPaymentTypeChoices(payment_types)

  return (
    <div>
      <Edit 
        editBackendPath={urls.promotionEditBackendPath}
        {...props}
      >
        <SimpleForm>
          <TextInput 
            source='name' 
            label='Name' 
            isRequired={true}
          />
          <DateInput 
            source='start' 
            label='Start Date' 
            disabled={true}
            options={{ disabled: true }}
          />
          <DateInput 
            source='end'
            label='End Date'
            disabled={true}
            options={{ disabled: true }}
          />
          <DisabledInput 
            choices={utils.QUOTA_TYPE_CHOICES}
            source='quota_type'
            label='Quota Type'
            isRequired={true}
            defaultValue={utils.QUOTA_TYPE_UNLIMITED}
          />
          { show_quota 
            ? <DisabledInput source='quota' label='Quota' isRequired={true} />
            : <HiddenInput source='quota' label='Quota' isRequired={true} /> 
          }
          <SelectInput
            source='payment_type_id'
            label='Payment Type'
            choices={payment_type_choices}
            disabled={true}
          />
          <BooleanInput
            source='is_active' 
            label="Status" 
            isRequired={true} 
            defaultValue={true}
          />
        </SimpleForm>
      </Edit>

      <br />

      <TriggerList 
        promotion_id={props.id}
        refreshTriggerList={() => {
          props.refreshTriggerList(props.id);
        }}
        crudUpdate={props.crudUpdate}
      />
    </div>
  );
}

export const PromotionEdit = connect(
  (state, props) => {
    const form_record = (state.form['record-form'] || {});
    return {
      id: decodeURIComponent(props.match.params.id),
      payment_types: state.admin[utils.PaymentTypeResourceName].data,
      formValues: form_record.values || {},
    }
  }, 
  (dispatch) => {
    return {
      customFetch: (id) => {
        dispatch(crudGetOneAction(
          utils.PromotionResourceName, 
          id,
          urls.promotionEditBackendPath,
          false
        ));
        dispatch(crudGetListAction(
          utils.ProductResourceName, 
          urls.productBackendPath,
          {},
          false
        ));
        dispatch(crudGetListAction(
          utils.PromotionBenefitResourceName, 
          urls.promotionBenefitBackendPath,
          {},
          false
        ));
        dispatch(crudGetListAction(
          utils.PromotionTriggerResourceName, 
          urls.promotionTriggerBackendPath,
          {
            promotion_id: id,
          },
          false
        ));
        dispatch(crudGetListAction(
          utils.PaymentTypeResourceName,
          urls.paymentTypeBackendPath,
          {},
          false
        ));
      },
      refreshTriggerList: (id) => {
        dispatch(crudGetListAction(
          utils.PromotionTriggerResourceName, 
          urls.promotionTriggerBackendPath,
          {
            promotion_id: id,
          },
          false
        ));
      },
    };
  }
)(PromotionEditBase);



// WEBPACK FOOTER //
// ./src/routes/product/PromotionEdit/index.js